module.exports = __webpack_public_path__ + "static/media/stress.1110d1dd.svg";